import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, BARCODE_LENGTH, DataType, DEFAULT_KEYPAD_MAX_COL, EMPTY_STRING, LoadingMessages, SystemParameter } from "src/app/common/Const";
import { ME000002, ME100010, ME200002, ME200003, ME200005, ME200007, ME200008, MI100001, MI200001, MI200002, MQ200002, MQ200005, MQ200006, MQ200010, MQ200011 } from "src/app/common/const-message-id";
import { GC_D0046_CANCELLED, GC_D0046_VALID, GC_D2016_NORMAL_SLIP, GC_D2083_IN_APPROVED, GC_D2083_OUT_APPROVED, GC_D2083_OUT_REJECTED, GC_D2083_OUT_REQUESTING } from "src/app/common/ConstCcd";
import { TableColumnDef } from "src/app/common/table-column-def";
import { BarcodeDialogComponent } from "src/app/dialog/barcode-dialog/barcode-dialog.component";
import { ErrorNotificationDialogComponent } from "src/app/dialog/error-notification-dialog/error-notification-dialog.component";
import { Spmt10261DetailDialogComponent } from "src/app/dialog/spmt10261-detail-dialog/spmt10261-detail-dialog.component";
import { Spmt10261SlipListDialogComponent } from "src/app/dialog/spmt10261-slip-list-dialog/spmt10261-slip-list-dialog.component";
import { BarcodeButtonComponent } from "src/app/partsCommon/barcode-button/barcode-button.component";
import { NumberKeypadComponent } from "src/app/partsCommon/number-keypad/number-keypad.component";
import { Req } from "src/app/request/req";
import { ReqAccess } from "src/app/request/req-access";
import { ReqGetStoreList } from "src/app/request/req-get-store-list";
import { ReqSpmt10261Confirm } from "src/app/request/req-spmt10261-confirm";
import { ReqSpmt10261Search } from "src/app/request/req-spmt10261-search";
import { ReqTmt003AllStoreSearch } from "src/app/request/req-tmt003-all-store-search";
import { ReqTmt790GetAllSystemParam } from "src/app/request/req-tmt790-get-all-system-param";
import { Rsp } from "src/app/response/rsp";
import { GetStoreListDto } from "src/app/response/rsp-get-store-list";
import { RspSpmt10261ProductSearch, RspSpmt10261SlipSearch, Spmt10261HeaderDto, Spmt10261SearchRowDto } from "src/app/response/rsp-spmt10261-search";
import { Tmt003StoreDto } from "src/app/response/rsp-tmt003-all-store-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";

interface TableRow extends Spmt10261SearchRowDto {
  form: {
    checkForm: FormControl;
    outStockQtyForm: FormControl;
    outSlipDtlCommentForm: FormControl;
  };
}

interface Header extends Spmt10261HeaderDto {
  form: {
    outSlipCommentForm: FormControl;
    outDateForm: FormControl;
    inStoreCdForm: FormControl;
  };
}

interface Spmt10261TableColumnDef extends TableColumnDef {
  type?: string;
}

enum ColumnIds {
  Check = "check",
  ProductCd = "productCd",
  ProductNm = "productNm",
  StandardNm = "standardNm",
  OutStockQty = "outStockQty",
  OutCostExc = "outCostExc",
  OutCostAmtExc = "outCostAmtExc",
  OutSellPriceExc = "outSellPriceExc",
  OutSellPriceAmtExc = "outSellPriceAmtExc",
  GMainClassNm = "gMainClassNm",
  GMidClassNm = "gMidClassNm",
  GSmallClassNm = "gSmallClassNm",
  GSubClassNm = "gSubClassNm",
  OutSlipDtlComment = "outSlipDtlComment",
  OutSlipDtlApproverComment = "outSlipDtlApproverComment",
  InSlipDtlApproverComment = "inSlipDtlApproverComment",
}

enum ColumnHeaders {
  Check = "削除",
  ProductCd = "商品コード",
  ProductNm = "商品名称",
  StandardNm = "規格",
  OutStockQty = "出庫数量",
  OutCostExc = "出庫原単価(抜)",
  OutCostAmtExc = "出庫原価金額(抜)",
  OutSellPriceExc = "出庫売単価(抜)",
  OutSellPriceAmtExc = "出庫売価金額(抜)",
  GMainClassNm = "大分類",
  GMidClassNm = "中分類",
  GSmallClassNm = "小分類",
  GSubClassNm = "細分類",
  OutSlipDtlComment = "出庫店伝票詳細コメント",
  OutSlipDtlApproverComment = "出庫店伝票詳細承認者コメント",
  InSlipDtlApproverComment = "入庫店伝票詳細承認者コメント",
}

class Constant {
  public static readonly STORE_CD_CTRL: string = "storeCd";
  public static readonly SLIP_NO_CTRL: string = "slipNo";
  public static readonly PRODUCT_CD_CTRL: string = "productCd";
  public static readonly NON_DIGIT_REGEX = /\D/g;
}

@Component({
  selector: "app-spmt10261",
  templateUrl: "./spmt10261.component.html",
  styleUrls: ["./spmt10261.component.css"],
})
export class Spmt10261Component implements OnInit, AfterViewInit {
  roundMode: string = "";
  maxQuantity: number = 0;
  dataSource = new MatTableDataSource<TableRow>([]);
  detailData: Header;
  columnIds: string[] = [
    ColumnIds.Check,
    ColumnIds.ProductCd,
    ColumnIds.ProductNm,
    ColumnIds.StandardNm,
    ColumnIds.OutStockQty,
    ColumnIds.OutCostExc,
    ColumnIds.OutCostAmtExc,
    ColumnIds.OutSellPriceExc,
    ColumnIds.OutSellPriceAmtExc,
    ColumnIds.GMainClassNm,
    ColumnIds.GMidClassNm,
    ColumnIds.GSmallClassNm,
    ColumnIds.GSubClassNm,
    ColumnIds.OutSlipDtlComment,
    ColumnIds.OutSlipDtlApproverComment,
    ColumnIds.InSlipDtlApproverComment,
  ];
  columnDefsItems: Spmt10261TableColumnDef[] = [
    { columnId: ColumnIds.Check, header: ColumnHeaders.Check, width: 45, align: Alginment.Center, checkbox: true, type: DataType.CHECKBOX },
    { columnId: ColumnIds.ProductCd, header: ColumnHeaders.ProductCd, width: 95, align: Alginment.Left, editable: true, type: DataType.LINK },
    { columnId: ColumnIds.ProductNm, header: ColumnHeaders.ProductNm, width: 200, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.StandardNm, header: ColumnHeaders.StandardNm, width: 95, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.OutStockQty, header: ColumnHeaders.OutStockQty, width: 70, align: Alginment.Right, type: DataType.INPUT_NUMBER },
    { columnId: ColumnIds.OutCostExc, header: ColumnHeaders.OutCostExc, width: 150, numberPipe: "1.2-2" },
    { columnId: ColumnIds.OutCostAmtExc, header: ColumnHeaders.OutCostAmtExc, width: 150, numberPipe: "1.0-0" },
    { columnId: ColumnIds.OutSellPriceExc, header: ColumnHeaders.OutSellPriceExc, width: 150, numberPipe: "1.2-2" },
    { columnId: ColumnIds.OutSellPriceAmtExc, header: ColumnHeaders.OutSellPriceAmtExc, width: 150, numberPipe: "1.0-0" },
    { columnId: ColumnIds.GMainClassNm, header: ColumnHeaders.GMainClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.GMidClassNm, header: ColumnHeaders.GMidClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.GSmallClassNm, header: ColumnHeaders.GSmallClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.GSubClassNm, header: ColumnHeaders.GSubClassNm, width: 150, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.OutSlipDtlComment, header: ColumnHeaders.OutSlipDtlComment, width: 180, align: Alginment.Left, type: DataType.INPUT_TEXT },
    { columnId: ColumnIds.OutSlipDtlApproverComment, header: ColumnHeaders.OutSlipDtlApproverComment, width: 180, align: Alginment.Left, type: DataType.TEXT },
    { columnId: ColumnIds.InSlipDtlApproverComment, header: ColumnHeaders.InSlipDtlApproverComment, width: 180, align: Alginment.Left, type: DataType.TEXT },
  ];

  access: ReqAccess = {
    ...this.commonService.loginUser,
  };
  storeCdList: GetStoreListDto[] = [];
  allStoreList: Tmt003StoreDto[] = [];

  itemTableWidth: any;
  tableWidth: any;

  checkAllControl: FormControl;
  isShowSearchCondition = true;

  searchCondition: FormGroup;
  @ViewChild("searchProductCode", { static: true }) searchProductCode: ElementRef;
  @ViewChild("keypad", { static: true }) numberKeypadComponent: NumberKeypadComponent;
  @ViewChild(BarcodeButtonComponent) barcodeButtonComponent: BarcodeButtonComponent;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(public commonService: CommonService, public httpBasic: HttpBasicService, private readonly message: MessageService, private readonly fb: FormBuilder) {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.searchCondition = this.fb.group(
      {
        storeCd: [EMPTY_STRING, Validators.required],
        slipNo: [EMPTY_STRING],
        productCd: [EMPTY_STRING],
      },
      {
        validators: this.atLeastOneFilled(Constant.SLIP_NO_CTRL, Constant.PRODUCT_CD_CTRL),
      }
    );

    this.detailData = {
      ...this.detailData,
      slipNo: EMPTY_STRING,
      outSlipApproverComment: EMPTY_STRING,
      inSlipApproverComment: EMPTY_STRING,
      form: {
        outSlipCommentForm: new FormControl(EMPTY_STRING),
        outDateForm: new FormControl(EMPTY_STRING, Validators.required),
        inStoreCdForm: new FormControl(EMPTY_STRING, Validators.required),
      },
    };

    this.checkAllControl = new FormControl(false);
    this.calcTableWidth();
    this.fnGetAccessInfo();
    this.set10KeyPadTarget(this.searchCondition.get(Constant.PRODUCT_CD_CTRL) as FormControl);
  }

  btnSearchClick() {
    if (!this.searchCondition.valid) {
      return;
    }
    if (this.dataSource.data.length > 0 && (this.searchCondition.value.storeCd != this.detailData.outStoreCd || this.searchCondition.value.slipNo != this.detailData.slipNo)) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200011]).subscribe((result) => {
        if (result) {
          this.dataSource.data = [];
          this.fnClearResult();
          this.fnSearch();
        }
      });
      return;
    }
    this.fnSearch();
  }

  fnSearch() {
    const request = this.fnGetRequestForSearch();
    if (this.searchCondition.value.slipNo && this.detailData.slipNo !== this.searchCondition.value.slipNo) {
      this.fnSearchSlip(request);
    } else {
      this.fnSearchProduct(request);
    }
  }

  private fnGetRequestForSearch(): ReqSpmt10261Search {
    const condition = this.searchCondition.value;
    return {
      access: this.access,
      ...condition,
      outDate: this.commonService.dateToString(this.detailData.form.outDateForm.value),
    };
  }

  private fnSearchSlip(request: ReqSpmt10261Search): void {
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10261SlipSearch(request).subscribe({
      next: (response: RspSpmt10261SlipSearch) => {
        if (this.httpBasic.handleAppError(response)) return;
        if (response.rows.length === 0) {
          this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI100001]);
          return;
        }
        this.detailData = {
          ...response.header,
          slipNo: response.header.slipNo ?? EMPTY_STRING,
          outSlipApproverComment: response.header.outSlipApproverComment ?? EMPTY_STRING,
          form: {
            outSlipCommentForm: new FormControl(response.header.outSlipComment),
            outDateForm: new FormControl(response.header.outDate, Validators.required),
            inStoreCdForm: new FormControl(response.header.inStoreCd),
          },
        };
        this.dataSource.data = response.rows.map((row) => ({
          ...row,
          form: {
            checkForm: new FormControl({ value: false, disabled: !this.isValidReqStatus() }),
            outStockQtyForm: new FormControl({ value: row.outStockQty, disabled: !this.isValidReqStatus() }),
            outSlipDtlCommentForm: new FormControl({ value: row.outSlipDtlComment, disabled: !this.isValidReqStatus() }),
          },
        }));
        this.checkAllControl.setValue(false);
        if (request.productCd) {
          request.outDate = response.header.outDate;
          this.fnSearchProduct(request);
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  private fnSearchProduct(request: ReqSpmt10261Search): void {
    if (
      (this.detailData.reqStatus && (this.detailData.reqStatus === GC_D2083_OUT_REJECTED || this.detailData.reqStatus === GC_D2083_IN_APPROVED)) ||
      this.detailData.slipCancelFlg === GC_D0046_CANCELLED
    ) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME200008]);
      return;
    }

    if (!request.productCd) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME000002].replace("%1", "商品コード入力"));
      this.searchProductCode.nativeElement.focus();
      return;
    }
    const productCode = request.productCd;
    const existingProduct = this.dataSource.data.find((item) => item.productCd === productCode);

    if (existingProduct) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME200007]?.replace("%1", "出庫一覧"));
      this.searchProductCode.nativeElement.focus();
      return;
    }

    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10261ProductSearch(request).subscribe({
      next: (response: RspSpmt10261ProductSearch) => {
        this.fnHandleProductSearchResponse(response);
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  fnHandleProductSearchResponse(response: RspSpmt10261ProductSearch) {
    if (this.httpBasic.handleAppError(response)) return;
    if (!response?.row?.productCd) {
      this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI100001]);
      return;
    }
    if (
      this.detailData.slipNo &&
      (this.detailData.tradeTaxKbn !== response.row.tradeTaxKbn || this.detailData.taxRate !== response.row.taxRate || this.detailData.taxRateCd !== response.row.taxRateCd)
    ) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200005]).subscribe((result) => {
        const createNewSlip = (result: boolean) => {
          if (!result) return;
          this.fnClearResult();
          this.searchCondition.get(Constant.SLIP_NO_CTRL).setValue(EMPTY_STRING);
          this.fnShowPopupDetail(response.row);
        };

        const cancelOperation = (result: boolean) => {
          if (result) return;
          this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
          this.searchProductCode.nativeElement.focus();
        };

        createNewSlip(result);
        cancelOperation(result);
      });
      return;
    }

    this.fnShowPopupDetail(response.row);
  }

  fnShowPopupDetail(product: Spmt10261SearchRowDto): void {
    this.detailData.outStoreCd = this.searchCondition.value.storeCd;
    const dialogRef = this.commonService.dialog.open(Spmt10261DetailDialogComponent, {
      data: {
        maxQuantity: this.maxQuantity,
        access: this.access,
        detailData: this.detailData,
        product,
        btnTitle: "追加",
      },
    });

    dialogRef.afterClosed().subscribe((data: Spmt10261SearchRowDto) => {
      if (data) {
        this.dataSource.data = [
          ...this.dataSource.data,
          {
            ...data,
            outCostAmtExc: this.commonService.roundNumber(data.outCostExc * data.outStockQty, 0, this.roundMode),
            outSellPriceAmtExc: this.commonService.roundNumber(data.outSellPriceExc * data.outStockQty, 0, this.roundMode),
            form: {
              checkForm: new FormControl(false),
              outStockQtyForm: new FormControl(data.outStockQty),
              outSlipDtlCommentForm: new FormControl(data.outSlipDtlComment),
            },
          },
        ];
        this.detailData.outStoreCd = this.detailData.outStoreCd || this.searchCondition.value.storeCd;
        this.detailData.slipNo = this.detailData.slipNo || this.searchCondition.value.slipNo;
        this.checkAllControl.setValue(false);
      }
      this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
      this.searchProductCode.nativeElement.focus();
    });
  }

  btnClearClick() {
    if (this.dataSource.data.length > 0) {
      this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200010]).subscribe((result) => {
        if (result) {
          this.fnClear();
        }
      });
      return;
    }
    this.fnClear();
  }

  checkOutStockQty(formControl: FormControl, item: TableRow, el?: HTMLInputElement) {
    if (!formControl.value) {
      this.fnShowError(this.message.message[ME100010], el);
    } else if (formControl.value < 1 || formControl.value > this.maxQuantity) {
      this.fnShowError(this.message.message[ME200005]?.replace("%1", "出庫数量").replace("%2", "1").replace("%3", this.maxQuantity.toString()), el);
    }
    item.outCostAmtExc = this.commonService.roundNumber(item.outCostExc * parseInt(formControl.value), 0, this.roundMode);
    item.outSellPriceAmtExc = this.commonService.roundNumber(item.outSellPriceExc * parseInt(formControl.value), 0, this.roundMode);
  }

  private fnShowError(errorMessage: string, el?: HTMLInputElement) {
    el?.blur();
    const dialogRef = this.commonService.dialog.open(ErrorNotificationDialogComponent, {
      data: {
        errorMessage: errorMessage,
        errorTitle: this.commonService.pageTitle,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      el?.focus();
      el?.setSelectionRange(el?.value.length, el?.value.length);
    });
  }

  btnConfirmClick(): void {
    if (!this.isValidReqStatus()) return;
    if (this.detailData.form.inStoreCdForm.value === this.detailData.outStoreCd) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME200002]);
      return;
    }
    if (!this.detailData.form.outDateForm.value) {
      this.commonService.openErrorDialog(this.commonService.pageTitle, this.message.message[ME000002].replace("%1", "出庫日"));
      return;
    }
    this.searchProductCode.nativeElement.focus();
    if (this.dataSource.data.length > 0) {
      for (let i = 0; i < this.dataSource.data.length; i++) {
        const formControl = this.dataSource.data[i].form.outStockQtyForm;
        if (!formControl.value) {
          const message = `レコード番号: ${i + 1}<br/>` + this.message.message[ME200003]?.replace("%1", "出庫数量");
          this.commonService.openErrorDialog(this.commonService.pageTitle, message);
          return;
        }
        if (formControl.value < 1 || formControl.value > this.maxQuantity) {
          const message = `レコード番号: ${i + 1}<br/>` + this.message.message[ME200005]?.replace("%1", "出庫数量").replace("%2", "1").replace("%3", this.maxQuantity.toString());
          this.commonService.openErrorDialog(this.commonService.pageTitle, message);
          return;
        }
      }
      const dialogRef = this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200006]);
      dialogRef.subscribe((data) => {
        if (data) {
          this.fnConfirm();
        }
      });
    }
  }

  private fnConfirm(): void {
    const request: ReqSpmt10261Confirm = this.fnGetRequestForRegistUpdate();
    this.httpBasic.beforeRequestStart(LoadingMessages.Registing);
    this.httpBasic.spmt10261Confirm(request).subscribe({
      next: (data: Rsp) => {
        if (this.httpBasic.handleAppError(data)) return;
        this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI200002]);
        this.fnClear();
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  fnGetRequestForRegistUpdate(): ReqSpmt10261Confirm {
    return {
      access: this.access,
      header: {
        ...{
          ...this.detailData,
          form: undefined,
        },
        inStoreCd: this.detailData.form.inStoreCdForm.value,
        outSlipComment: this.detailData.form.outSlipCommentForm.value,
        outDate: this.commonService.dateToString(this.detailData.form.outDateForm.value),
      },
      rows: this.dataSource.data.map((row) => ({
        ...row,
        changeFlg: row.outStockQty != row.form.outStockQtyForm.value || row.outSlipDtlComment != row.form.outSlipDtlCommentForm.value,
        outStockQty: row.form.outStockQtyForm.value,
        outSlipDtlComment: row.form.outSlipDtlCommentForm.value,
        form: undefined,
      })),
    };
  }

  onChangeRowCheck() {
    this.checkAllControl.setValue(this.dataSource.data.length > 0 && this.dataSource.data.filter((item) => item.form.checkForm.value).length === this.dataSource.data.length);
  }

  checkAll($event: any): void {
    this.dataSource.data.forEach((item) => {
      item.form.checkForm.setValue($event.checked);
    });
  }

  fnIsDisableDeleteButton(): boolean {
    const res = this.dataSource.data.length == 0 || this.dataSource.data.filter((item) => item.form.checkForm.value).length == 0;
    return res;
  }

  fnIsDisableConfirmButton(): boolean {
    const isChangeTable = this.dataSource.data.some(
      (item) => !item.systemSlipDetailNo || (item.systemSlipDetailNo && (item.outStockQty != item.form.outStockQtyForm.value || item.outSlipDtlComment != item.form.outSlipDtlCommentForm.value))
    );
    const isChangeHeader = this.detailData.form.outSlipCommentForm.value != this.detailData.outSlipComment;
    const isEnable = this.dataSource.data.length > 0 && (isChangeTable || isChangeHeader) && this.isValidReqStatus();
    return !isEnable;
  }

  btnDeleteClick(): void {
    this.searchProductCode.nativeElement.focus();
    if (!this.fnIsDisableDeleteButton()) {
      const dialogRef = this.commonService.openYesNoDialog(this.commonService.pageTitle, this.message.message[MQ200002]);
      dialogRef.subscribe((result) => {
        if (result) {
          this.fnDeleteList();
        }
      });
    }
  }

  fnDeleteList(): void {
    this.checkAllControl.setValue(this.dataSource.data.length > 0 && this.dataSource.data.filter((item) => item.form.checkForm.value).length === this.dataSource.data.length);
    const request = this.fnGetRequestForDelete();
    if (request.rows.length == 0) {
      this.execDelete();
      return;
    }
    this.httpBasic.beforeRequestStart(LoadingMessages.Deleting);
    this.httpBasic.spmt10261Confirm(request).subscribe({
      next: (response: Rsp) => {
        if (this.httpBasic.handleAppError(response)) return;
        this.execDelete();
        if (this.dataSource.data.length !== 0) {
          const storeCd = this.detailData.outStoreCd;
          const slipNo = this.detailData.slipNo;
          this.fnClear();
          this.searchCondition.patchValue({
            storeCd,
            slipNo,
            productCd: "",
          });
          this.fnSearch();
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  execDelete() {
    this.commonService.openNotificationDialog(this.commonService.pageTitle, this.message.message[MI200001]);
    this.dataSource.data = this.dataSource.data.filter((item: TableRow) => !item.form.checkForm.value);
    this.checkAllControl.setValue(false);
    if (this.dataSource.data.length == 0) {
      this.fnClear();
    }
  }

  fnGetRequestForDelete(): ReqSpmt10261Confirm {
    return {
      access: this.access,
      header: {
        ...{
          ...this.detailData,
          form: undefined,
        },
      },
      deleteFlg: true,
      rows: this.dataSource.data
        .filter((item) => item.systemSlipDetailNo)
        .map((row) => ({
          ...row,
          deleteFlg: row.form.checkForm.value,
          form: undefined,
        })),
    };
  }

  fnClear(): void {
    this.searchCondition.reset();
    this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
    this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
    this.searchProductCode.nativeElement.focus();

    this.fnClearResult();
  }

  private fnClearResult() {
    this.detailData = {
      form: {
        outDateForm: new FormControl(EMPTY_STRING, Validators.required),
        outSlipCommentForm: new FormControl(EMPTY_STRING),
        inStoreCdForm: new FormControl(this.allStoreList.length > 0 ? this.allStoreList[0].storeCd : EMPTY_STRING, Validators.required),
      },
    };

    this.checkAllControl.setValue(false);
    this.dataSource.data = [];
  }

  onClickLink(item: TableRow) {
    this.fnShowPopupDetailLink(item);
  }

  fnShowPopupDetailLink(item: TableRow): void {
    const dialogRef = this.commonService.dialog.open(Spmt10261DetailDialogComponent, {
      data: {
        maxQuantity: this.maxQuantity,
        access: this.access,
        detailData: this.detailData,
        product: {
          ...item,
          outStockQty: item.form.outStockQtyForm.value,
          outSlipDtlComment: item.form.outSlipDtlCommentForm.value,
        },
        btnTitle: "更新",
      },
    });

    dialogRef.afterClosed().subscribe((data: Spmt10261SearchRowDto) => {
      if (data) {
        item.outCostAmtExc = this.commonService.roundNumber(data.outCostExc * data.outStockQty, 0, this.roundMode);
        item.outSellPriceAmtExc = this.commonService.roundNumber(data.outSellPriceExc * data.outStockQty, 0, this.roundMode);
        item.form.outStockQtyForm.setValue(data.outStockQty);
        item.form.outSlipDtlCommentForm.setValue(data.outSlipDtlComment);
      }
      this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(EMPTY_STRING);
      this.searchProductCode.nativeElement.focus();
    });
  }

  isValidReqStatus(): boolean {
    return (
      (!this.detailData.reqStatus || this.detailData.reqStatus === GC_D2083_OUT_REQUESTING || this.detailData.reqStatus === GC_D2083_OUT_APPROVED) &&
      (!this.detailData.redBlackFlg || this.detailData.redBlackFlg === GC_D2016_NORMAL_SLIP) &&
      (!this.detailData.slipCancelFlg || this.detailData.slipCancelFlg === GC_D0046_VALID)
    );
  }

  fnGetAccessInfo() {
    let req: Req = {
      access: this.access,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.getUserInfo(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        if (res.rows.length > 0) {
          this.access.cmpnyCd = res.rows[0].mainCmpnyCd;
          this.access.storeCd = res.rows[0].mainStoreCd;
          this.access.sysModeCd = res.rows[0].sysModeCd;
          this.access.lang = res.rows[0].mainLang;
          this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
          this.initScreen();
        }
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  initScreen() {
    this.getStoreList();
    this.getSystemParam();
    this.getAllStoreList();
  }

  private getAllStoreList() {
    let request: ReqTmt003AllStoreSearch = {
      access: this.access,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.tmt003AllStoreSearch(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.allStoreList = res.rows;
        this.detailData.form.inStoreCdForm.setValue(this.allStoreList.length > 0 ? this.allStoreList[0].storeCd : EMPTY_STRING);
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private getSystemParam() {
    let request: ReqTmt790GetAllSystemParam = {
      access: this.access,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.tmt790GetAllSystemParam(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        const maxQuantity = res.rows.find((row) => row.key === SystemParameter.CM0007)?.value;
        const roundMode = res.rows.find((row) => row.key === SystemParameter.ST0007)?.value;
        if (maxQuantity) {
          this.maxQuantity = Number(maxQuantity);
        }
        this.roundMode = roundMode;
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  private getStoreList() {
    let request: ReqGetStoreList = {
      access: this.access,
      storeCd: EMPTY_STRING,
      userId: EMPTY_STRING,
      cmpyCd: this.access.cmpnyCd,
      sysModeCd: this.access.sysModeCd,
    };

    this.httpBasic.beforeRequestStart(LoadingMessages.Initializing);
    this.httpBasic.getStoreList(request).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.storeCdList = res.rows;
        this.searchCondition.get(Constant.STORE_CD_CTRL).setValue(this.access.storeCd);
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => this.httpBasic.afterRequestComplete(),
    });
  }

  atLeastOneFilled(ctrl1: string, ctrl2: string) {
    return (formGroup: FormControl) => {
      const control1 = formGroup.get(ctrl1);
      const control2 = formGroup.get(ctrl2);
      const isValid = !!control1?.value || !!control2?.value;

      return isValid ? null : { atLeastOneFilled: true };
    };
  }

  calcTableWidth() {
    this.tableWidth = { width: "100%" };
  }

  isKeyboardLocked() {
    return this.numberKeypadComponent.isKeyboardLocked() ?? false;
  }

  checkIs10KeyPadTarget(ctrl: string) {
    return this.is10KeyPadTarget(this.searchCondition.get(ctrl) as FormControl);
  }

  is10KeyPadTarget(ctrl: FormControl): boolean {
    return ctrl === this.numberKeypadComponent.inputField;
  }

  setKeyPad(control: string, maxCol: number = DEFAULT_KEYPAD_MAX_COL, stringMode: boolean = false) {
    if (maxCol === BARCODE_LENGTH) {
      this.barcodeButtonComponent.forcusIn();
    }
    this.set10KeyPadTarget(this.searchCondition.get(control) as FormControl, maxCol, stringMode);
  }

  targetTableRow: TableRow;
  set10KeyPadTarget(control: FormControl, maxCol: number = DEFAULT_KEYPAD_MAX_COL, stringMode: boolean = false, item?: TableRow) {
    if (maxCol === BARCODE_LENGTH && this.barcodeButtonComponent) {
      this.barcodeButtonComponent.forcusIn();
    }
    if (!this.commonService.config.use10KeyPad) {
      return;
    }
    this.targetTableRow = item;
    this.numberKeypadComponent.setTargetForm(control);
    this.numberKeypadComponent.setMaxCol(maxCol);
    this.numberKeypadComponent.setStringMode(stringMode);
  }

  openErrDialog(msg: string) {
    this.commonService.dialog.open(ErrorNotificationDialogComponent, {
      data: {
        errorMessage: msg,
        errorTitle: this.commonService.pageTitle,
      },
    });
  }

  onScan(barcode: string) {
    if (barcode) {
      this.fnExecAfterScan(barcode);
    }
  }

  private fnExecAfterScan(barcode: string) {
    let productCd = barcode;
    if (this.commonService.config.loginBarcode) {
      productCd = barcode.substring(this.commonService.config.loginBarcode.start, this.commonService.config.loginBarcode.end);
    }
    productCd = productCd.replace(Constant.NON_DIGIT_REGEX, EMPTY_STRING);
    this.searchCondition.get(Constant.PRODUCT_CD_CTRL).setValue(productCd);
    if (productCd) {
      const request = this.fnGetRequestForSearch();
      this.fnSearchProduct(request);
    }
  }

  openBarcodeDialog() {
    const dialogRef = this.commonService.dialog.open(BarcodeDialogComponent, {
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data != undefined && data != null) {
        this.fnExecAfterScan(data);
      }
    });
  }

  fnClearTargetForm() {
    this.numberKeypadComponent.setTargetForm(undefined);
  }

  btnListSlipNoClick(): void {
    const dialogRef = this.commonService.dialog.open(Spmt10261SlipListDialogComponent, {
      autoFocus: false,
      data: {
        access: { ...this.access },
        storeCd: this.searchCondition.get(Constant.STORE_CD_CTRL).value,
        storeNm: this.storeCdList.find((x: GetStoreListDto) => x.storeCd == this.searchCondition.get(Constant.STORE_CD_CTRL).value).storeDetail,
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.slipNo !== this.searchCondition.get(Constant.SLIP_NO_CTRL).value) {
        this.searchCondition.get(Constant.SLIP_NO_CTRL).setValue(data.slipNo);
        this.btnSearchClick();
      }
    });
  }

  isCheckboxAllDisabled() {
    return this.dataSource.data.length === 0 || this.dataSource.data.every((item) => item.form.checkForm.disabled);
  }

  onValueChange(value: string) {
    if (!this.targetTableRow) return;
    this.checkOutStockQty(this.targetTableRow.form.outStockQtyForm, this.targetTableRow);
  }
}
